import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Typography,
  useTheme,
  TablePagination,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useState } from "react";

const CustomCardList = ({
  data,
  onCardClick,
  fields,
  page,
  rowsPerPage,
  totalCount,
  onPageChange,
  onRowsPerPageChange,
  dropdownField, // Field key for dropdown (e.g., "status")
  dropdownOptions = [], // Dropdown options
  onDropdownChange, // Function to handle dropdown value change
  DropdownLabel
}) => {
  const theme = useTheme();
  const totalPages = Math.ceil(totalCount / rowsPerPage);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, padding: "1px" }}>
      {data.map((item) => (
        <Card
          key={item.id}
          onClick={() => onCardClick && onCardClick(item)}
          sx={{
            boxShadow: 2,
            padding: "5px",
            marginBottom: "8px",
            borderRadius: "12px",
          }}
        >
          <CardContent>
            <Typography variant="h6" sx={{ fontSize: "1rem", fontWeight: 600 }}>
              {item.name}
            </Typography>
            {fields.map((field, index) => (
              <Typography key={index} variant="body2" sx={{ fontSize: "0.875rem" }}>
                {field.label}: {item[field.key]}
              </Typography>
            ))}

            {/* Conditional Dropdown */}
            {dropdownField && (
              <Box sx={{ marginTop: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 600}}>
                  {DropdownLabel}:
                </Typography>
                <Select
                  value={item[dropdownField]}
                  onChange={(e) => onDropdownChange(e, item)}
                  sx={{ minWidth: 200 }}
                >
                  {dropdownOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            )}
          </CardContent>
        </Card>
      ))}

      {/* Pagination Controls */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px",
          backgroundColor: theme.palette.mode === "dark" ? "#333" : "#f9f9f9",
          borderRadius: "8px",
          boxShadow: 1,
          position: "sticky",
          bottom: "0",
        }}
      >
        <IconButton
          onClick={(e) => onPageChange(e, page - 1)}
          disabled={page === 0}
          size="small"
        >
          <ArrowBackIosNewIcon fontSize="small" />
        </IconButton>
        <Typography variant="body2">
          Page {page + 1} of {totalPages}
        </Typography>
        <IconButton
          onClick={(e) => onPageChange(e, page + 1)}
          disabled={page >= totalPages - 1}
          size="small"
        >
          <ArrowForwardIosIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default CustomCardList;
